export default __webpack_public_path__ + "static/media/cooking.1093ea1d.png";